import React, { useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthProvider";
import { getPostLoginHomePath } from "../helpers/accountProduct";
import { SESSION_STORAGE } from "../helpers/constants";

const V2_ENTRY_KEY = "lo_v2_entry";

const PROTECTED_ROUTE_PREFIXES = [
  "/chat",
  "/whats-wrong",
  "/rent",
  "/rent-dashboard",
  "/leases",
  "/bids",
  "/leo",
  "/engine",
  "/automation",
  "/offers",
  "/referrals",
  "/profile",
  "/v2/",
];

function isOnProtectedRoute(pathname) {
  return PROTECTED_ROUTE_PREFIXES.some((route) => pathname.startsWith(route));
}

const PostLoginRedirect = () => {
  const { user, userInfo, loading, isUserInfoLoading } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const authInitializedRef = useRef(false);
  const hadUserRef = useRef(false);

  useEffect(() => {
    if (loading || isUserInfoLoading) return;

    const isAuthPage =
      location.pathname === "/login" || location.pathname === "/signup";

    if (!user) {
      if (!authInitializedRef.current) {
        authInitializedRef.current = true;
      }
      hadUserRef.current = false;
      return;
    }

    if (!authInitializedRef.current) {
      authInitializedRef.current = true;
      hadUserRef.current = true;
      if (isAuthPage) {
        navigate(getPostLoginHomePath(userInfo), { replace: true });
      }
      return;
    }

    if (hadUserRef.current) return;
    hadUserRef.current = true;

    const isV2Entry = sessionStorage.getItem(V2_ENTRY_KEY) === "1";
    if (isV2Entry) {
      sessionStorage.removeItem(V2_ENTRY_KEY);
      navigate("/v2/simulation", { replace: true });
      return;
    }

    const redirectUrl = sessionStorage.getItem(SESSION_STORAGE.redirectUrl);
    if (redirectUrl) {
      sessionStorage.removeItem(SESSION_STORAGE.redirectUrl);
      navigate(redirectUrl, { replace: true });
      return;
    }

    if (isOnProtectedRoute(location.pathname)) return;

    navigate(getPostLoginHomePath(userInfo), { replace: true });
  }, [
    user,
    loading,
    userInfo,
    isUserInfoLoading,
    navigate,
    location.pathname,
  ]);

  return null;
};

export default PostLoginRedirect;
